import { useState } from 'react';
import useGetCreatedJobPosts from '../jobs/useGetCreatedJobPosts';
import useGetActiveJobPosts from '../jobs/useGetActiveJobPosts';

const useDashboardLoading = () => {
  const [loading, setLoading] = useState(false);
  const { getCreatedJobPosts } = useGetCreatedJobPosts();
  const { getActiveJobPosts } = useGetActiveJobPosts();

  const getDashboardLoadingData = (userId: string) => {
    setLoading(true);

    if (userId) {
      Promise.all([getCreatedJobPosts(), getActiveJobPosts()])
        .then(() => setLoading(false))
        .catch(() => setLoading(false));
    }
  };

  return { getDashboardLoadingData, loading };
};

export default useDashboardLoading;
